import { render, staticRenderFns } from "./AttributeIcons.vue?vue&type=template&id=74853f8d&scoped=true&"
import script from "./AttributeIcons.vue?vue&type=script&lang=js&"
export * from "./AttributeIcons.vue?vue&type=script&lang=js&"
import style0 from "./AttributeIcons.vue?vue&type=style&index=0&id=74853f8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74853f8d",
  null
  
)

export default component.exports